import { Component } from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import qs from 'qs';
import { withRouter } from 'react-router';
import makeQuery from 'yoda-core-components/lib/navigation/query/makeQuery';

export const parseURL = (url) => {
    /* istanbul ignore else */
    if (!__SERVER__ && url) {
        const a = document.createElement('a');
        a.href = url;
        return a;
    }
    return {};
};

class Canonincalize extends Component {
    static defaultProps = {
        location: {},
        productDetails: {},
        router: {},
    };

    static propTypes = {
        productDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        location: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        router: PropTypes.oneOfType([PropTypes.object]),
    };

    componentDidMount() {
        /* istanbul ignore else */
        if (this.props.productDetails) {
            this.amendUrl();
        }
    }

    componentWillReceiveProps(nextProps) {
        /* istanbul ignore else */
        if (this.props.productDetails !== nextProps.productDetails) {
            this.amendUrl();
        }
    }

    amendUrl = () => {
        const { location } = this.props;
        const links = get(this.props, 'productDetails.links');
        const query = makeQuery(location.search);
        const pageQueryParams = query || {};
        /* istanbul ignore else */
        if (links && links.url && links.rel === 'canonical') {
            const canonicalUrl = parseURL(links.url);
            const canonicalQueryParams = qs.parse(canonicalUrl.search);
            /* istanbul ignore next */
            if (
                canonicalUrl.pathname !== location.pathname ||
                canonicalQueryParams.pTmplType !== pageQueryParams.pTmplType
            ) {
                pageQueryParams.pTmplType = canonicalQueryParams.pTmplType;

                this.props.router.replace({
                    pathname: canonicalUrl.pathname,
                    query: { ...pageQueryParams, ...canonicalQueryParams },
                });
            }
        }
    };

    render() {
        return null;
    }
}

export default withRouter(Canonincalize);
